import { Controller } from "@hotwired/stimulus";
import { escapeExpression } from "hb/lib/utils";
import { useOutlets } from "hb/insights/use_outlets";

export default class extends Controller {
  connect() {
    useOutlets(this, { components: ["handsfree"] });
  }

  toggleShowHandsfree() {
    this.element.classList.toggle("show-handsfree");
  }

  valSel(evt) {
    if (!window.getSelection().isCollapsed) {
      return;
    }

    const { target } = evt;
    const ds = evt.target.dataset;
    let val = ds.value;
    let context = ds.context || "error";
    let prepend = [];

    // If target is a href don't bubble up
    if (target.tagName === "A") {
      evt.stopPropagation();
      evt.preventDefault();
      val = target.href;
      prepend.push({ op: "open", value: val, display: "open URL" });
    }

    if (ds.errorSearchUrl !== undefined) {
      prepend.push({
        op: "errorSearch",
        value: ds.errorSearchUrl,
        display: `find errors with <strong>${escapeExpression(ds.errorPath || ds.path)}</strong>`,
      });
    }

    if (prepend.length > 0) {
      prepend.push({ divider: true, display: "Insights Queries" });
    }

    this.outletComponent("handsfree").show("str", ds.path, val, {
      prepend,
      context,
      element: this.element,
      addToField: false,
    });
  }
}
